import React, {useState} from 'react';
import styles from '../AddRateModal.module.scss';
import {useTranslation} from 'react-i18next';
import {useStylesBox} from './styleCustom';
import InputTextField from './../../InputTextField';

interface CurrencySelectorProps {
    selectValue: {[key: string]: string};
    setAddObj: React.Dispatch<React.SetStateAction<any>>;
};

const AmountInput = ({setAddObj, selectValue}: CurrencySelectorProps) => {
    const classesInput = useStylesBox();
    const [focus, setFocus] = useState(false);
    const {t} = useTranslation();
    const minAmount = 1; // item.minPrice/Number(currencyMap?.filter((e: any) => e.currency == item?.currency)[0]?.conversionFactor || 100) || 1;
    const maxAmount = 50000; // item.maxPrice/Number(currencyMap?.filter((e: any) => e.currency == item?.currency)[0]?.conversionFactor || 100) || 50000;
    return (
        <div style={{position: 'relative'}}>
        <InputTextField
              type="number"
              placeholder={t("amount")}
              value={selectValue.price}
              customStyle={{height: '56px', padding: '0px 20px'}}
              onChange={(e: any) => {
                setAddObj({...selectValue, price: e.target.value});
              }}
              onFocus={() => setFocus(true)}
            />
        {focus && parseInt(selectValue.price) <= minAmount && <div className={`${styles.amountError}`}>{`${t('amount_should_be_greater_than')} ${minAmount || 1}`}</div>}
        {focus && parseInt(selectValue.price) > maxAmount && <div className={`${styles.amountError}`}>{`${t('amount_should_be_less_than')} ${maxAmount || 5000}`}</div>}
        </div>
    );
};

export default AmountInput;
